import { render } from "./CoverListHeader.vue?vue&type=template&id=bc40d416"
import script from "./CoverListHeader.vue?vue&type=script&lang=js"
export * from "./CoverListHeader.vue?vue&type=script&lang=js"

import "./CoverListHeader.vue?vue&type=style&index=0&id=bc40d416&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__